<ng1-profile-pupil-medical [selectedPerson]="selectedPerson"
                           [isOrganisationAdmin]="isOrganisationAdmin"
                           [misManaged]="misManaged"></ng1-profile-pupil-medical>
